import React, { useEffect, useState } from 'react'
import { Button, Card, Table } from "antd";
import { getCategoriesWithPage } from "../../services/serviceCategory";
import CategoryActions from "./CategoryActions";
import CategoryCreate from "./CategoryCreate";

const Category = () => {
    const [sortedList, setSortedList] = useState([]);
    const [newModal, setNewModal] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        getCategory(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize]);

    const getCategory = (page, pageSize) => {
        getCategoriesWithPage(page - 1, pageSize)
            .then(({ data }) => {
                handlers.sortData(data.content);
                setPagination({
                    ...pagination,
                    total: data.totalElements
                })
            })
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        setPagination({
            ...pagination,
            current: pageNumber,
            pageSize: pageSize
        });
    };

    const handlers = {
        updater() {
            getCategory(1, 10);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            let sorted = []
            list.forEach(item => {
                let pushObj = {
                    key: item.id,
                    id: item.id,
                    categoryName: item.name,
                    categoryCode: item.code,
                    categoryDescription: item.description,
                    categoryBrand: item.brand.code,
                    brand: item.brand
                }
                sorted.push(pushObj)
            })
            setSortedList(sorted)
        }
    };

    const columns = [
        {
            title: 'Adı',
            dataIndex: 'categoryName',
            key: 'categoryName'
        },
        {
            title: 'Kodu',
            dataIndex: 'categoryCode',
            key: 'categoryCode'
        },
        {
            title: 'Marka',
            dataIndex: 'categoryBrand',
            key: 'categoryBrand'
        },
        {
            title: 'İşlemler',
            key: 'action',
            render: (text, record) => record.categoryName.toLowerCase() === 'armaled' ? null : <CategoryActions record={record} updater={handlers.updater} />
        }
    ];

    return (
        <React.Fragment>
            <Card title={'Kategori Listesi'} extra={<Button onClick={() => setNewModal(!newModal)} type={'primary'}> Yeni Ekle </Button>}>
                <Table
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={sortedList}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </Card>

            {newModal ? <CategoryCreate show={newModal} modalCloser={handlers.modalCloser} updater={handlers.updater} /> : null}

        </React.Fragment>
    )
}
export default Category